<template>
    <div class="request-type-disclaimers__container">
        <p v-for="(option, index) in options" :key="option.id">
            <b>
                <span :class="{'employee-icon__container': index== 0}">
                    <i class="ml-3 mr-1" :class="option.icon"></i>
                </span>
                {{ option.label }}:
            </b>
            <span>{{ option.disclaimer }}</span>
        </p>
    </div>
</template>
  
<script>
export default {
    components: {
    },
    props: {
        options: {
            type: Array,
            required: true,
            default: () => ([])
        },
    },
};
</script>

<style scoped>
.request-type-disclaimers__container {
    background-color: #F4F6F3;
    border-radius: 5px;
    margin: 15px -15px;
    padding: 30px 20px;
    color: #727272;
}

.employee-icon__container {
    margin-right: 6px !important;
}
</style>